import { routeConstants } from "constants/routeConstants";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "slice";
import { useGetCountriesQuery } from "slice/common";
import {
    updateNewJobData,
    updateSelectedEditJob,
    useAgencyJobListingQuery,
} from "slice/jobs";
import { AgencyJob } from "./types";

export const useMyJobListings = (type?: string) => {
    const { agency } = useAppSelector((state) => state.user);
    const dispatch = useDispatch();
    const {
        data,
        isError: isErrorJobs,
        isLoading: isJobsLoading,
        refetch,
    } = useAgencyJobListingQuery({
        agency_id: agency?.id ?? "",
        type: type ?? "",
    });

    const { data: countries, isError: isErrorCountries } = useGetCountriesQuery(
        {}
    );

    const [isLoading, setIsLoading] = useState(true);

    const [agencyJobs, setAgencyJobs] = useState<AgencyJob[]>([]);
    const [agencyJobCount, setAgencyJobCount] = useState<number>(0);

    const navigateTo = useNavigate();

    const handleEditJob = (id: string) => {
        dispatch(updateNewJobData({}));
        dispatch(updateSelectedEditJob({ payload: id }));
        navigateTo(
            routeConstants.jobs.editAJob.root +
                id +
                "/" +
                routeConstants.jobs.editAJob.category
        );
    };

    const formatBudgetType = (type: string): string => {
        if (type === "") return "";
        const array = type.split("_");
        return array.map((a) => a[0].toUpperCase() + a.slice(1)).join(" ");
    };

    useEffect(() => {
        if (
            data &&
            countries &&
            data.jobs?.length > 0 &&
            countries!.length > 0
        ) {
            setAgencyJobs(
                data.jobs?.map((job) => {
                    return {
                        id: job.id,
                        title: job.title,
                        gender: job.gender ?? "",
                        no_of_seats: job.no_of_seats,
                        budget_type: formatBudgetType(job.budget_type ?? ""),
                        ageMin: job.applicant_min_age,
                        ageMax: job.applicant_max_age,
                        applicants: job.applications_count ?? 0,
                        created_at: job.created_at,
                        updated_at: job.updated_at,
                        location: `${job.city}`,
                        applicants_list: job.applicants,
                    };
                })
            );
            setAgencyJobCount(data.count ?? 0);
            setIsLoading(false);
        } else {
            setAgencyJobs([]);
            setAgencyJobCount(0);
        }
    }, [countries, data, type]);

    useEffect(() => {
        if (isErrorCountries || isErrorJobs) {
            setIsLoading(false);
        }
    }, [isErrorCountries, isErrorJobs]);

    return {
        agencyJobs,
        agencyJobCount,
        isLoading,
        handleEditJob,
        refetch,
        isJobsLoading,
    };
};
